
import _ from 'lodash';

export default function (error, action, resource) {
    console.log(`${action} ${resource} errored`, error);
    let resultError = { code: "failed", message: `${action} ${resource} failed` };
    if (error.code && error.message) {
        resultError.code = error.code;
        resultError.message = error.message;
    }
    if (error.isAxiosError) {
        if (error.response && (error.response.status === 403 || error.response.status === 404)) {
            const base = error.response.status === 403
                ? { code: "PERMISSION_DENIED", message: `Permission denied` }
                : { code: "NOT_FOUND_ERROR", message: `Resource not found` };
            const data = error.response.data;
            if (data && typeof data === "object") {
                if (data.code) base.serverCode = data.code;
                if (data.message) base.serverMessage = data.message;
            }
            return base;
        }
        if (error.response) {
            let responseError = error.response.data;
            if (responseError && Object.keys(responseError).length > 0) {
                resultError = { ...resultError, ...responseError };
            }
        }
        if (resultError.fields && resultError.fields.length > 0) {
            resultError.fields = resultError.fields.reduce((errorObj, field) => {
                errorObj[field.name] = _.isArray(field.errors) ? field.errors.join("\n") : field.errors;
                return errorObj;
            }, {});
        }
    }
    return resultError;
}